// extracted by mini-css-extract-plugin
export var card = "_64-0";
export var failedIcon = "_64-4";
export var failedIconBadge = "_64-3";
export var icon = "_64-1";
export var successIcon = "_64-2";